import * as React from "react";
import "../../style/fonts.css";
import "./regEmail.css";
import Checkbox from "../checkbox/checkbox";
import CtaButton from "../ctaButton/ctaButton";
import hidden_pass from "../../icons/hidden.svg";
import visible_pass from "../../icons/visible.svg";
import Input from "../input/input";
import {
  registerWithEmail,
  resetRegNewUser,
  resetNewUserAndProfile,
  resetRegWarnings,
} from "src/store/actions/authActions";
import {
  checkUsername,
  checkPassword,
  resetUsernameWarning,
  resetPasswordWarning,
  setUsernameDuplicateWarning,
} from "src/store/actions/regActions";
import { createUser, createProfile } from "src/store/actions/authActions";
import { connect } from "react-redux";
import { createEmptyProfile } from "../../functions/createProfile";
import { createEmptyUser } from "../../functions/createUser";
import { Redirect, Link } from "react-router-dom";
import translate from "../../translations/i18n";
import detectBrowserLanguage from "detect-browser-language";
import { isUsernameTaken } from "./regFacebook";
import { duplicateSearch } from "../../functions/searchApis";

export interface Props {
  resetNewUserAndProfile(): void;
  resetRegNewUser(): void;
  registerWithEmail(credentials): void;
  createUser(emptyUser): void;
  createProfile(emptyProfile): void;
  authError: any;
  auth: any;
  usernameDub: boolean;
  usernameError: string;
  passwordError: any;
  emailError: any;
  didRegister: any;
  createUserCompleted: any;
  createProfileCompleted: any;
  resetRegWarnings: () => void;
  resetPasswordWarning: () => void;
  resetUsernameWarning: () => void;
  checkUsername: (username, minLength, maxLength) => void;
  checkPassword: (minLength, password) => void;
  setUsernameDuplicateWarning: () => void;
}

interface State {
  username: string;
  email: string;
  password: string;
  conditionPrivacy: boolean;
  conditionTerms: boolean;
  conditionHealthData: boolean;
  usernameWarning: any;
  emailWarning: string;
  nullUsername: boolean;
  seePassword: boolean;
  buttonDisabled: boolean;
}

class RegEmail extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      email: "",
      password: "",
      conditionPrivacy: false,
      conditionTerms: false,
      conditionHealthData: false,
      usernameWarning: null,
      nullUsername: true,
      seePassword: false,
      emailWarning: null,
      buttonDisabled: true,
    };
    this.register = this.register.bind(this);
    this.resetVariables = this.resetVariables.bind(this);
    this.acceptConditionPrivacy = this.acceptConditionPrivacy.bind(this);
    this.acceptConditionTerms = this.acceptConditionTerms.bind(this);
    this.acceptConditionHealthData = this.acceptConditionHealthData.bind(this);
  }

  componentDidMount() {
    this.props.resetRegWarnings();
    this.props.resetPasswordWarning();
    this.props.resetUsernameWarning();
  }
  handleChangeUsername(event) {
    this.setState({ username: event.target.value });
    this.props.checkUsername(event.target.value, 3, 18);
  }

  handleChangeMail(event) {
    this.setState({ email: event.target.value });
  }

  handleChangePass(event) {
    this.setState({ password: event.target.value });
    this.props.checkPassword(8, event.target.value);
  }

  passSeen() {
    this.setState((prevState) => ({
      seePassword: !prevState.seePassword,
    }));
  }

  acceptConditionPrivacy() {
    this.setState((prevState) => ({
      conditionPrivacy: !prevState.conditionPrivacy,
    }));
  }
  acceptConditionHealthData() {
    this.setState((prevState) => ({
      conditionHealthData: !prevState.conditionHealthData,
    }));
  }

  acceptConditionTerms() {
    this.setState((prevState) => ({
      conditionTerms: !prevState.conditionTerms,
    }));
  }

  infoConditionPrivacy = () => {
    const lang = String(detectBrowserLanguage()).includes("de") ? "de" : "en";
    const url = "https://static.smokeless.world/" + lang + "/privacy.html";
    this.openUrl(url);
  };

  infoConditionTerms = () => {
    const lang = String(detectBrowserLanguage()).includes("de") ? "de" : "en";
    const url = "https://static.smokeless.world/" + lang + "/terms.html";
    this.openUrl(url);
  };
  infoConditionHealthData = () => {
    const lang = String(detectBrowserLanguage()).includes("de") ? "de" : "en";
    const url = "https://static.smokeless.world/" + lang + "/health_data.html";
    this.openUrl(url);
  };

  openUrl(url: string) {
    const win = window.open(url, "_blank");
    if (win != null) {
      win.focus();
    }
  }

  showEye() {
    if (this.state.seePassword) return <img src={hidden_pass} />;
    else return <img src={visible_pass} />;
  }

  register = () => {
    this.props.checkUsername(this.state.username, 3, 18);
    this.props.checkPassword(8, this.state.password);
    if (
      !this.props.passwordError &&
      !this.props.usernameError &&
      this.state.conditionTerms&&
      this.state.conditionHealthData&&
      this.state.conditionPrivacy
    ) {
      duplicateSearch(this.state.username)
        .then((result) => {
          if (!isUsernameTaken(result)) {
            this.props.registerWithEmail(this.state);
          } else {
            this.props.setUsernameDuplicateWarning();
          }
        })
        .catch((error) => {
          this.props.setUsernameDuplicateWarning();
        });
    }
  };

  componentDidUpdate(prevProps) {
    if (
      this.props.didRegister === true &&
      prevProps.auth.uid !== this.props.auth.uid
    ) {
      const emptyUser = createEmptyUser(this.props.auth.uid);
      const emptyProfile = createEmptyProfile(
        this.state.username,
        this.props.auth.uid
      );
      this.props.createUser(emptyUser);
      this.props.createProfile(emptyProfile);
    }
  }

  resetVariables() {
    this.props.resetRegNewUser();
    this.props.resetNewUserAndProfile();
  }

  checkButton = () => {
    if (
      !this.props.passwordError &&
      this.state.password != "" &&
      this.state.username != "" &&
      !this.props.usernameError &&
      this.state.conditionTerms&&
      this.state.conditionHealthData&&
      this.state.conditionPrivacy
    ) {
      return false;
    } else {
      return true;
    }
  };

  render() {
    if (this.props.createProfileCompleted && this.props.createUserCompleted) {
      this.resetVariables();
      return <Redirect to="/registerProgress" push />;
    }

    return (
      <div className="REGEMAIL">
        <div className="REG_TITLE">
          <div className="TITLE_2">
            {translate("SUPPORT_REGISTER_AND_LOGIN_TITLE")}
          </div>
        </div>
        <div className="USERNAME_INPUT">
          <Input
            type={"text"}
            placeholder={translate("USERNAME_FORM")}
            value={this.state.username}
            onChange={this.handleChangeUsername.bind(this)}
            warning={
              this.props.usernameError && translate(this.props.usernameError)
            }
            passwordSeen={null}
          />
        </div>
        <div className="EMAIL_INPUT">
          <Input
            type={"text"}
            placeholder={translate("EMAIL_FORM")}
            value={this.state.email}
            onChange={this.handleChangeMail.bind(this)}
            warning={this.props.emailError && translate(this.props.emailError)}
            passwordSeen={null}
          />
        </div>
        <div className="PASSWORD_INPUT">
          <Input
            type={"password"}
            placeholder={translate("PASSWORD_FORM")}
            value={this.state.password}
            onChange={this.handleChangePass.bind(this)}
            warning={
              this.props.passwordError && translate(this.props.passwordError)
            }
            passwordSeen={this.state.seePassword}
          />
          <div className="PASS_ICON" onClick={this.passSeen.bind(this)}>
            {this.showEye()}
          </div>
          <div className="OVERVIEW_TEXT"></div>

        </div>
        <div className="CHECKBOX_1">
          <div className="REG_TEXT">{translate("CONSENT_TEXT_1_1")}</div>
          <div className="REG_TEXT CONSENT_TEXT_1_2">{translate("CONSENT_TEXT_1_2")}</div>
          <div className="CHECK_AREA">
            <Checkbox
              onClick={this.acceptConditionPrivacy.bind(this)}
              text={translate("CONSENT_DATA_SECURITY")}
              checked={this.state.conditionPrivacy}
              onClickInfo={this.infoConditionPrivacy}
            />
          </div>
        
          <div className="CHECK_AREA">
            <Checkbox
              onClick={this.acceptConditionTerms.bind(this)}
              text={translate("CONSENT_TERMS")}
              checked={this.state.conditionTerms}
              onClickInfo={this.infoConditionTerms}
            />
          </div>
          <div className="CHECK_AREA">
            <Checkbox
              onClick={this.acceptConditionHealthData.bind(this)}
              text={translate("CONSENT_HEALTH_DATA")}
              checked={this.state.conditionHealthData}
              onClickInfo={this.infoConditionHealthData}
            />
          </div>
          <div className="REG_TEXT">{translate("CONSENT_TEXT_2")}</div>
       
          <div className="CREATE_ACCBUTTON">
            <CtaButton
              width={"280px"}
              text={translate("CTA_CREATE_NEW_ACCOUNT")}
              color={"white"}
              disabled={this.checkButton()}
              onClick={this.register.bind(this)}
            />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    authError: state.auth.authError,
    auth: state.firebase.auth,
    usernameDub: state.reg.usernameDub,
    usernameError: state.reg.usernameError,
    passwordError: state.reg.passwordError,
    emailError: state.auth.emailError,
    didRegister: state.auth.regEmailCompleted,
    createUserCompleted: state.auth.createUserCompleted,
    createProfileCompleted: state.auth.createProfileCompleted,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    registerWithEmail: (creds) => dispatch(registerWithEmail(creds)),
    createUser: (emptyUser) => dispatch(createUser(emptyUser)),
    createProfile: (emptyProfile) => dispatch(createProfile(emptyProfile)),
    checkUsername: (username, minLength, maxLength) =>
      dispatch(checkUsername(username, minLength, maxLength)),
    checkPassword: (minLength, password) =>
      dispatch(checkPassword(minLength, password)),
    resetRegNewUser: () => dispatch(resetRegNewUser()),
    resetNewUserAndProfile: () => dispatch(resetNewUserAndProfile()),
    resetRegWarnings: () => dispatch(resetRegWarnings()),
    resetUsernameWarning: () => dispatch(resetUsernameWarning()),
    resetPasswordWarning: () => dispatch(resetPasswordWarning()),
    setUsernameDuplicateWarning: () => dispatch(setUsernameDuplicateWarning()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RegEmail);



// WEBPACK FOOTER //
// ./src/components/Registration/regEmail.tsx